// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/page/announcement/Announcement.css
// module id = 187
// module chunks = 0